import { Component, Input, Output, OnInit, EventEmitter, HostListener, ElementRef, ViewChild } from '@angular/core';
import { TranslationService, AutocompleteService, ValueModel } from '../../core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'sm-multiselect',
	template: require('./sm-multiselect.component.html')
})
export class SmMultiSelectComponent implements OnInit {
	@Input('single') isSingleSelect: boolean = false;
	@Input() label: string;
	@Input() selected: ValueModel[] = [];
	@Input() values: ValueModel[] = [];
	@Input('datasource') dataSource: string = '';
	@Output('select') onSelect: EventEmitter<ValueModel[]> = new EventEmitter();

	@ViewChild('drop') drop: NgbDropdown;

	get text(): string { return (this.selected && this.selected.length > 0) ? this.selected.map(s => s.name).join(', ') : this._emptyTxt; }
	get inputType(): string { return this.isSingleSelect ? 'radio' : 'checkbox'; }

	loading: boolean = false;
	collapsed: boolean = true;
	private _emptyTxt: string;

	constructor(
		private _translationService: TranslationService,
		private _autocompleteService: AutocompleteService,
		private _element: ElementRef
	) {
		this._emptyTxt = _translationService.getString('Vybrat');
	}

	ngOnInit() {
		if (this.dataSource) {
			this.loading = true;

			this._autocompleteService
				.get(this.dataSource)
				.subscribe(
					data => this.values = data,
					error => console.error(error),
					() => this.loading = false
				);
		}
	}

	@HostListener('document:click', ['$event'])
	onClick(event: any) {
		// is click outside
		if (!this.collapsed && !this._element.nativeElement.contains(event.target)) {
			this.collapsed = true;
			this.drop.close();
			this.select();
		}
	}

	toggle() {
		this.collapsed = !this.collapsed;
	}

	clear() {
		this.selected.length = 0;
		if (this.onSelect) {
			this.onSelect.emit([]);
		}
	}

	select() {
		if (this.onSelect) {
			this.onSelect.emit(this.selected);
		}

		this.drop.close();
		this.collapsed = true;
	}

	selectValue(value: ValueModel) {
		if (this.isSingleSelect) {
			this.selected.length = 0;
		}

		const idx = this.selected.indexOf(value);
		if (idx > -1) {
			this.selected.splice(idx, 1);
		}
		else {
			this.selected.push(value);
		}
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-multiselect.component.ts